<template>
  <div class="agreement" v-loading.fullscreen="isLoading">
    <div v-if="remoteContent" v-html="remoteContent"></div>
    <section v-else-if="lang === 'en-US'" class="en-us-box">
      <p>
        This Agreement is a contract entered into between user (“you”) and the
        Digital Platform of China International Fair for Trade in Services
        (hereinafter referred to as “the CIFTIS Digital Platform”) on matters
        related to services, etc. of CIFTIS website (www.ciftis.org, “this
        website”) and CIFTIS Mobile APP (“this APP”). Please read this Agreement
        carefully. After you click the “Agree” button, this Agreement will
        constitute a legally binding instrument for both parties. The CIFTIS
        Digital Platform aims to provide users with products and services
        demonstrated on this website (hereinafter referred to as “CIFTIS
        services” or “the services”), and will continuously update contents of
        the services. For the latest CIFTIS services, the page contents
        describing relate products and services on this website and this APP,
        and the actually delivered products and services should prevail.
      </p>
      <h3>1. General</h3>
      1.1 You confirm that: Before using the services, you have fully read,
      understood and accepted all the provisions of this Agreement (especially
      the bolded and/or underlined ones). Once you click the “Agree” button and
      complete the registration process, or use the services, it means that you
      agree to observe all provisions of this Agreement.
      <br />
      <h4>
        1.2 You agree that: The CIFTIS Digital Platform has the right to
        unilaterally revise provisions of this Agreement and corresponding
        service rules at any time, and to publish the revised provisions through
        message pushing, webpage announcement, etc., without further and
        separate notice. If you continue to use the services after revised
        provisions of this Agreement are notified, it means that you have fully
        read, understood and accepted the revised provisions, and will use the
        services in accordance with the revised provisions of this Agreement. If
        you disagree with the revised provisions, please stop using the services
        immediately.
      </h4>
      <h3>2. Account</h3>
      <h4>2.1 Registration</h4>
      2.1.1 Registration qualification
      <br />
      (1) You confirm that: When you complete the registration procedures or
      actually use the services in other way(s) permitted by the CIFTIS Digital
      Platform, you are a natural person, legal person or other organization
      that has the full capacity for civil rights and civil conduct (hereinafter
      collectively referred to as “legal subject”).
      <br />
      (2) You will not be qualified as the subject mentioned above if you are a
      minor, or a person with limited capacity for civil conduct. You and your
      guardian should take all the consequences caused by your improper act of
      registration, and the CIFTIS Digital Platform has the right to cancel
      (permanently freeze) your account, and claim reimbursement from you and
      your guardian.
      <br />
      2.1.2 Registration, account and real-name authentication
      <br />
      (1) You will be bound by provisions of this Agreement after you fill in
      the information according to the instructions of registration page, read
      and agree to provisions of this Agreement and complete all the
      registration procedures, or actually use the services of this website and
      this APP in other way(s) permitted by the CIFTIS Digital Platform. You may
      access this website by logging in through the provided or confirmed email
      address, mobile phone number or other way(s) permitted by the CIFTIS
      Digital Platform.
      <br />
      (2) You understand and agree that, after you complete the registration
      procedures and register successfully on this website or this APP, you have
      obtained an account of the CIFTIS Digital Platform.
      <br />
      (3) Currently in the CIFTIS Digital Platform, an account corresponds to a
      unique legal subject. You are not allowed to transfer, donate or make
      others inherit your account in the CIFTIS Digital Platform in any way,
      except as otherwise stipulated by law or determined by effective legal
      documents, or if conditions published by the CIFTIS Digital Platform are
      met. Meanwhile, when you transfer, donate or make others inherit your
      account in the CIFTIS Digital Platform, the CIFTIS Digital Platform has
      the right to require you and/or your grantee or inheritor, to provide
      qualified documents and handle related matters as per the operation
      procedures required by the CIFTIS Digital Platform.
      <br />
      (4) You understand and agree that, to ensure the security of your account,
      transaction and exhibition participation, the CIFTIS Digital Platform has
      the right to require you to complete the real-name authentication of your
      account in the platform at any time. Meanwhile, the CIFTIS Digital
      Platform may also require you to provide more identity materials and
      information for the opening of certain products or services, to facilitate
      the further identity authentication or qualification verification. Your
      account can obtain the qualification for using related products or
      services only after passing such authentication and verification.
      <br />
      (5) Normally, your account in the CIFTIS Digital Platform is the unique
      identification basis for conducting activities on this website or this
      APP, and each account in the CIFTIS Digital Platform can conduct
      activities on this website independently. Under the following
      circumstances, however, the CIFTIS Digital Platform will, according to its
      own judgment, uniformly handle multiple accounts in the CIFTIS Digital
      Platform owned by the same and/or associated legal subject(s), including
      but not limited to:
      <br />
      a) Where association relationships such as main account and sub-account,
      and authorizing account and authorized account exist among accounts in the
      CIFTIS Digital Platform, and each account bears joint responsibility for
      the other according to laws and regulations, provisions of this Agreement
      or other rules of the CIFTIS Digital Platform;
      <br />
      b) Where multiple accounts in the CIFTIS Digital Platform share the same
      real-name authentication, and two or more of such accounts simultaneously
      have acts of maliciously violating the laws and regulations, provisions of
      this Agreement or other rules of the CIFTIS Digital Platform;
      <br />
      c) Where one or more pieces of registration information is(are) the same
      among multiple accounts in the CIFTIS Digital Platform or other related
      situations occur, there are acts of maliciously violating the laws and
      regulations, provisions of this Agreement or other rules of the CIFTIS
      Digital Platform, and the CIFTIS Digital Platform is able to judge that
      the above accounts in the CIFTIS Digital Platform actually belong to the
      same legal subject or same group by combining with other related evidence;
      <br />
      d) Other situations where the CIFTIS Digital Platform has the sufficient
      reason to uniformly handle multiple accounts in the CIFTIS Digital
      Platform.
      <br />
      2.1.3 Information
      <br />
      (1) When completing the registration procedures, you should accurately
      provide and timely update your data as per corresponding page instructions
      in accordance with requirements of laws and regulations, to make such data
      true, timely, complete and accurate. If the CIFTIS Digital Platform has
      reasonable grounds to suspect that the information you have provided is
      incorrect, inaccurate, outdated or incomplete, it has the right to send a
      notice for inquiry and/or correction to you, and directly delete
      corresponding data, until suspending or terminating providing some or all
      the services to you.
      <strong
        >The CIFTIS Digital Platform will assume no responsibility for this, and
        you should take any resulting direct or indirect losses and negative
        consequences.</strong
      >
      <br />
      (2) You should accurately fill in and update contacts such as the e-mail
      address, contact phone number (or mobile phone number), contact address
      and postal code you provide, to facilitate the CIFTIS Digital Platform or
      other members to have effective contact(s) with you. Any losses or
      additional expenses incurred during your use of the services of the CIFTIS
      Digital Platform as you are available through these contacts shall be
      borne by yourself independently. You understand and agree that, you are
      obliged to maintain the validity of contacts you provide. If the contacts
      need to be updated due to changes, please operate according to the
      requirements of the CIFTIS Digital Platform.
      <br />
      <h4>2.2 Account Security</h4>
      2.2.1 You shall be responsible for the confidentiality of your account and
      password on the CIFTIS digital platform, and shall be responsible for all
      activities (including but not limited to information disclosure,
      information publication, online consent by click or submission of various
      rule agreements, online renewal agreements or purchase of services) that
      occur under such login name and password. You agree the following: (a) If
      it is found that anyone used your account and password on the CIFTIS
      digital platform without authorization or any other circumstances in
      violation of confidentiality provisions occur, you will inform the CIFTIS
      digital platform immediately and authorize the CIFTIS digital platform to
      synchronize such information with relevant service systems of CIFTIS; (b)
      you will leave the site with the correct steps at the end of each access
      to the Internet. The CIFTIS digital platform shall not and will not be
      liable for any loss or damage arising from your failure in complying with
      the provisions of this paragraph. You understand that the CIFTIS digital
      platform will take a reasonable amount of time to act on your request.
      <strong
        >The CIFTIS digital platform will not be liable for any consequences
        (including but not limited to any loss incurred to you) that have
        occurred before taking actions.</strong
      >
      <br />
      2.2.2 You understand and agree that the CIFTIS digital platform is
      entitled to know the true background and purpose of your use of the
      products and services of the website, and is entitled to request you to
      provide truthful, comprehensive and accurate information; if it is
      suspected that the information provided by you is not true and that you
      conducted any false transaction with reasonable reasons, or that your
      behavior violated rules of the CIFTIS digital platform, the CIFTIS digital
      platform is entitled to restrict part or all of the functions of all
      products and/or services used under your account temporarily or
      permanently.
      <br />
      2.2.3 You understand and agree that the CIFTIS digital platform is
      entitled to suspend or restrict part or all of the functions under your
      account temporarily based on requirements of operation and transaction
      security.
      <br />
      2.2.4 You understand and agree that the CIFTIS digital platform is
      entitled to query, freeze or deduct your personal information, funds,
      transactions and accounts on the website and/or the APP according to the
      requirements of national judicial, administrative, military and security
      authorities (including but not limited to the public security authority,
      prosecuting authority, court, customs, tax authority, security
      department).
      <br />
      <h4>2.3 Account Cancellation</h4>
      2.3.1 The CIFTIS digital platform reserves the right to suspend or
      terminate provision of services to you in part or in whole, or even cancel
      your account on the CIFTIS digital platform in case that you violate
      national or local laws and regulations or these Terms of Service.
      <br />
      2.3.2 Cancellation of Account Name
      <br />
      <strong
        >(1) You understand and agree that the CIFTIS digital platform is
        entitled to cancel your user name, and you will no longer be able to log
        on to the website or APP of the CIFTIS digital platform if you are not
        logged in the website with your user name, email address, mobile phone
        or other methods approved by this website and password for 12
        consecutive months.</strong
      >
      <br />
      (2) You agree and authorize that the CIFTIS digital platform and other
      relevant service system are entitled to disclose your behaviors of fraud,
      publication or sale of fake and inferior goods, infringement of the
      legitimate rights and interests of others, or other serious violation of
      any rule of the CIFTIS digital platform on such digital platform or
      offline CIFTIS exhibition, or other offline exhibition held by CIFTIS
      (Beijing), and your user name on the CIFTIS digital platform may be
      cancelled. After the cancellation, you will no longer be able to log on to
      the website and APP of the CIFTIS digital platform, and the services of
      the CIFTIS digital platform will be terminated simultaneously.
      <br />
      2.3.3 You guarantee that you will not take any action or method that will
      affect, impair or may affect or impair the legitimate rights and interests
      of the CIFTIS digital platform and/or its affiliates, the associated
      online and/or offline exhibitions (including but not limited to: CIFTIS,
      ICCIE, FINEXPO, BITE, World Winter Sports (Beijing) Expo, Beijing
      International Robot Exhibition) and their sponsors and organizers, such
      actions or methods that will affect or impair the legitimate rights and
      interests of CIFTIS digital platform include but are not limited to:
      <br />
      2.3.3.1 Violate any service agreement/term, management norm, trading rule
      and other provision issued by the CIFTIS digital platform;
      <br />
      2.3.3.2 Disrupt or attempt to disrupt the normal operation order of the
      CIFTIS digital platform;
      <br />
      2.3.3.3 Use any name or brand of CIFTIS that is misleading to others or
      use any Chinese or English (full name or abbreviation), number, domain
      name or other intent to express or reflect the certain relationship with
      the CIFTIS digital platform;
      <br />
      2.3.3.4 Other circumstances that are considered likely to be of the same
      nature as the above behavior or to generate similar risks as above based
      on the reasonable judgment of the CIFTIS digital platform.
      <br />
      You agree that the CIFTIS digital platform is entitled to terminate
      provision of the services to you if you violate the above agreement,
      namely, you will no longer be able to log on to the website or APP of the
      CIFTIS digital platform, and all services of the CIFTIS digital platform
      will be terminated simultaneously.
      <h3>3. Codes for Use of Website Services</h3>
      In order to effectively protect your legitimate rights and interests
      during the use of the Service, you understand and agree to accept the
      following rules:
      <br />
      3.1 The instructions sent to the CIFTIS digital platform by you through
      ways including but not limited to the following, shall be deemed as your
      own instructions, which cannot be revoked or cancelled, you shall be
      solely responsible for any consequences arising from the execution of the
      above instructions by the CIFTIS digital platform.
      <br />
      3.1.1 All operations performed through your account and password on the
      CIFTIS digital platform;
      <br />
      3.1.2 All information sent to the CIFTIS digital platform through the
      mobile phone number bound to your account;
      <br />
      3.1.3 All information sent to the CIFTIS digital platform through physical
      or non-physical means such as other hardware, terminal, software,
      designation, code, passphrase, other account name that is bound to your
      account;
      <br />
      3.1.4 Other ways agreed between you and the CIFTIS digital platform or
      approved by the CIFTIS digital platform.
      <br />
      3.2 During the use of the Service, the contents of these Terms of Service,
      the prompts on the page about the transaction operation or the information
      (SMS or phone call, etc.) sent to your mobile phone by the CIFTIS digital
      platform are the relevant rules for you to use the Service, your use of
      the Service means your acceptance of relevant rules of the Service. You
      understand and agree the CIFTIS digital platform is entitled to modify the
      rules of the Service unilaterally without your permission. The rules of
      the Service shall be subject to the prompts on the page when you use the
      service (or SMS or phone call sent to the mobile phone, etc.). Your
      consent to and compliance with the rules of the Service are prerequisites
      for your use of the Service.
      <br />
      3.3 The CIFTIS digital platform may inform you of the service progress and
      prompt you to take the next step by E-mail (or SMS or phone call sent to
      the mobile phone, etc.), but the CIFTIS digital platform will not
      guarantee that you will receive or receive the email (or SMS or phone call
      sent to the mobile phone, etc.) in a timely manner, and shall not be
      responsible for any consequence arising therefrom. Therefore, you shall
      log on to the website to view and conduct transactions in a timely manner
      during the Service. The CIFTIS digital platform shall not be responsible
      for any dispute or loss caused by your failure in timely viewing and
      modifying or confirming the service status or failure in submitting the
      relevant application.
      <br />
      3.4 You authorize the CIFTIS digital platform to check your identity and
      qualifications with a third party so as to obtain information about your
      use of the Service.
      <br />
      3.5 Before the use of certain product or service of the CIFTIS digital
      platform, you may be required to execute a separate service agreement with
      the CIFTIS digital platform for such product or service. You may use the
      product or service only if you accept the entire contents of the service
      agreement; please do not process the subsequent operation if you do not
      agree to part or all of the service agreement.
      <br />
      3.6 During your use of corresponding product and service of the CIFTIS
      digital platform, a specific service agreement (including but not limited
      to these Terms of the Service and Service Level Agreement of each product)
      will be executed between you and the CIFTIS digital platform. In case of
      any conflict between the service agreement for the specific product and
      this Agreement, the specific service agreement shall prevail; and in case
      of no provision in the specific agreement, this Agreement shall prevail.
      <br />
      3.7 Complaint and handling
      <br />
      3.7.1 In the process of using the services of the CIFTIS Digital Platform,
      you are likely to be subject to the measures such as stopping all or part
      of services, restricting all or part of services, freezing all or part of
      account funds, etc. by the CIFTIS Digital Platform in case of one of the
      situations listed in Article 5.3 of this Terms of Service, the CIFTIS
      Digital Platform will notify you by mail, internal message, SMS or
      telephone to follow the corresponding procedures to complain.
      <br />
      3.7.2 If you apply to the CIFTIS Digital Platform to lift the above
      restrictions or freeze or to resume services through the complaint
      procedures, you should truthfully provide identification and related
      information and other information or documents required by the CIFTIS
      Digital Platform in accordance with the requirements of the CIFTIS Digital
      Platform, so that the CIFTIS Digital Platform can verify them. You should
      fully understand that your complaint is not necessarily allowed, and the
      CIFTIS Digital Platform has the right to decide whether to agree with your
      complaint request at its own discretion.
      <br />
      <strong
        >3.7.3 You understand and agree that if you refuse to truthfully provide
        identification and related information, or fail to pass the review by
        the CIFTIS Digital Platform, the CIFTIS Digital Platform has the right
        to freeze these accounts for a long time and restrict some or all
        functions of the products or services for a long time.</strong
      >
      <br />
      <h4>3.8 About the third party</h4>
      <br />
      <strong
        >3.8.1 If you will use any products or services from the third party due
        to using this service, you may also be subject to the relevant terms and
        conditions of the third party. The CIFTIS Digital Platform will not
        interfere it or assume any responsibility for it. This Terms of Service
        does not affect your legal relationship with the third party.</strong
      >
      <br />
      3.8.2 You confirm and agree that all affiliates of the CIFTIS Digital
      Platform are third party beneficiaries of this Terms of Service, and have
      the right to directly enforce and rely on any provisions on benefits
      granted to them in this Terms of Service. In addition, no third party
      should be the third party beneficiary of this Terms of Service.
      <h3>4. Your rights and obligations</h3>
      4.1 You have the right to enjoy the Internet technology and information
      services as well as technical support and consulting services provided by
      the CIFTIS Digital Platform. For details of the services, please refer to
      the relevant product introduction on this website.
      <br />
      4.2 You guarantee that you will not use the services of the CIFTIS Digital
      Platform to engage in activities that endanger national interests,
      collective interests, and the legitimate interests of citizens, nor
      jeopardize the service security of the CIFTIS Digital Platform, nor use
      technology or other means to destroy or disturb the websites of other
      customers of the CIFTIS Digital Platform, nor make, copy, or publish
      illegal information containing the following content:
      <br />
      (I) Opposing the basic principles established by the Constitution;
      <br />
      (II) Endangering national security, leaking state secrets, subverting
      state power, and undermining national unity;
      <br />
      (III) Undermining national honor and interests;
      <br />
      (IV) Distorting, defaming, desecrating and denying the deeds and spirit of
      the heroes and martyrs, and infringing on the names, portraits,
      reputation, and honors of the heroes and martyrs by insulting, defaming,
      etc.;
      <br />
      (V) Promoting terrorism or extremism or inciting terrorist or extremist
      activities;
      <br />
      (VI) Inciting ethnic hatred, ethnic discrimination, and undermining ethnic
      unity;
      <br />
      (VII) Undermining national religious policies and promoting cults and
      feudal superstitions;
      <br />
      (VIII) Spreading rumors and disrupting economic and social order;
      <br />
      (IX) Spreading obscenity, pornography, gambling, violence, homicide or
      terror or abetting crimes;
      <br />
      (X) Insulting or defaming others, infringing on the reputation, privacy
      and other legal rights of others;
      <br />
      (XI) Other contents prohibited by laws and administrative regulations.
      <br />
      4.3 According to relevant national laws and regulations, you also agree to
      strictly abide by the following obligations:
      <br />
      (1) You must comply with relevant Chinese laws and regulations when
      transferring information from mainland China to overseas;
      <br />
      (2) Do not use this website to engage in illegal activities such as money
      laundering, stealing business secrets, and stealing personal information;
      <br />
      (3) Do not interfere with the normal operation of this website, nor invade
      this website and the national computer information system
      <br />
      (4) Do not transmit or publish any illegal, harassing, slanderous,
      abusive, intimidating, harmful, vulgar and uncivilized information;
      <br />
      (5) Do not abet others to engage in behaviors that are against laws and
      regulations or prohibited by the Agreement or platform rules;
      <br />
      (6) Do not use the account registered on this website for profit-making
      business activities;
      <br />
      (7) Do not publish any content that violates the personal information,
      intellectual property rights such as copyright, trademark right, etc. or
      legal rights of others;
      <br />
      4.4 You should be legally responsible for your online speech and actions.
      If you distribute and disseminate reactionary, pornographic or other
      information that violates national laws on this website, the system
      records of this website may be used as evidence of your violation of the
      law.
      <br />
      4.5 You should respect the intellectual property rights and other legal
      rights of the CIFTIS Digital Platform and other third party, and ensure
      that in the event of violations of the above rights and interests, you
      will try your best to protect the CIFTIS Digital Platform and its
      shareholders, employees, partners, etc. from being affected by or
      suffering losses due to these events. The CIFTIS Digital Platform reserves
      the right to terminate the services provided to you and not refund any
      money when you violate the legitimate rights and interests of the CIFTIS
      Digital Platform.
      <br />
      4.6 You should take responsibility for any consequences caused by
      incorrect contact information provided by you to the CIFTIS Digital
      Platform, the discontinuation of your mobile phone number, and the poor
      security and stability of the e-mail address you use to receive mail from
      the CIFTIS Digital Platform, including but not limited to the consequences
      and losses caused by your failure to receive relevant notices from the
      CIFTIS Digital Platform in a timely manner.
      <br />
      4.7 You guarantee that:
      <br />
      4.7.1. When using the products and services of the CIFTIS Digital
      Platform, you will abide by national and local laws and regulations,
      industry practices and social public morals, and prevent and resist the
      producing, copying, and publishing of bad information containing the
      following content: using exaggerated titles, where the content is
      seriously inconsistent with the title; hyping affairs, scandals, bad
      behaviors, etc.; improperly commenting on disasters such as natural
      disasters and major accidents; with sexual cues, sexual teasing, etc. that
      easily lead to sexual associations; showing bloody, thrilling, cruel, etc.
      leading to physical and mental discomforts; inciting crowd discrimination,
      regional discrimination, etc.; promoting vulgar and kitsch content; may
      cause minors to imitate unsafe behaviors and to violate social morality,
      or induce minors' bad habits, etc.; other content which has adverse
      effects on the network ecology.
      <br />
      4.7.2. When using the products and services of the CIFTIS Digital
      Platform, you should abide by the terms of service you signed with the
      CIFTIS Digital Platform, the management specifications, processes, service
      descriptions, and price descriptions of the CIFTIS Digital Platform on the
      relevant pages of www.ciftis.org as well as the content of the order page
      confirmed and agreed by you, including but not limited to: (1) You should
      not disrupt or attempt to disrupt network security, etc.;
      <br />
      (2) You should not utilize any non-network review or filing nor rely on
      technical means to transmit cross-border illegal information through the
      use of the services of the CIFTIS Digital Platform. 4.7.3. You and your
      affiliates are not the targets of service trade restrictions or sanctions
      imposed by any country, international organization or region or of other
      legal restrictions.
      <br />
      If you violate the above guarantees, the CIFTIS Digital Platform has the
      right to delete information, suspend services or terminate services as
      well as restrict some or all functions of your account such as
      participation in exhibitions, commercial promotion, etc. according to the
      relevant service terms. Suspected illegal act will be reported to the
      relevant judicial supervision department. You should compensate for any
      losses of the CIFTIS Digital Platform caused by your above actions.
      <br />
      4.8 If any service used by you contains downloadable CIFTIS Digital
      Platform software, the CIFTIS Digital Platform only grants you a
      non-exclusive, non-transferable, non-commercial operation license for
      personal use. Unless expressly stated otherwise by the CIFTIS Digital
      Platform or unless otherwise agreed with you, you should not copy, modify,
      publish, sell or rent any part of the service or the contained software,
      nor do reverse engineering or attempt to extract the source code of the
      software.
      <br />
      4.9 If your business information system deployed on the CIFTIS Digital
      Platform meets or must meet the national-level protection rating or the
      requirements specified by the industry and competent authority, you should
      meet the corresponding level security requirements according to law,
      obtain the corresponding security certification or approval, and receive
      the security inspections by relevant departments.
      <h3>5. The rights and obligations of the CIFTIS Digital Platform</h3>
      5.1 The CIFTIS Digital Platform should provide you with qualified network
      technology and information services based on the services you choose and
      the payment status.
      <br />
      5.2 Unless the following situations, the CIFTIS Digital Platform promises
      to take measures to keep your data confidential, not to disclose your data
      to the third party, nor authorize the third party to use your data:
      <br />
      5.2.1 It can be provided according to the provisions of this Terms of
      Service or other service agreements, contracts, online terms, etc. between
      you and the CIFTIS Digital Platform;
      <br />
      5.2.2 It should be provided in accordance with the provisions of laws and
      regulations;
      <br />
      5.2.3 The administrative, judicial and other authorities require the
      CIFTIS Digital Platform to provide it;
      <br />
      5.2.4 You agree the CIFTIS Digital Platform to provide it for the third
      party;
      <br />
      5.2.5 It is submitted by the CIFTIS Digital Platform to resolve the
      reported incident or to file a lawsuit;
      <br />
      5.2.6 It must be submitted by the CIFTIS Digital Platform to take
      necessary and reasonable actions to prevent serious illegal acts or
      suspected criminal acts;
      <br />
      5.2.7 It is submitted by the CIFTIS Digital Platform to the third party to
      provide products, services and information for you, including the case
      where the CIFTIS Digital Platform provides you with products, services and
      information through third party technologies and services.
      <br />
      5.3 In case of one of the following situations, the CIFTIS Digital
      Platform has the right to freeze some or all of the account functions and
      account funds under your name:
      <br />
      5.3.1 The national laws, regulations, policies and legal documents require
      to freeze it:
      <br />
      5.3.2 The state competent authority requires to freeze it:
      <br />
      5.3.3 Your use of the services of the CIFTIS Digital Platform is suspected
      of violating national laws, regulations and administrative regulations;
      <br />
      5.3.4 Based on its unilateral reasonable judgment, the CIFTIS Digital
      Platform believes that there are abnormalities in your account operations,
      capital in and out, etc.;
      <br />
      5.3.5 Someone else incorrectly remits funds into your account and lead to
      your unjust enrichment:
      <br />
      5.3.6 You have been complained by others who has provided certain
      evidence:
      <br />
      5.3.7 Based on its own reasonable judgment, the CIFTIS Digital Platform
      believes that there are other situations that may cause risks. After the
      CIFTIS Digital Platform freezes your account funds in accordance with the
      aforementioned provisions, it will notify you by mail, internal message,
      SMS or telephone to follow the corresponding procedures to complain. If
      you fail to complain within the specified time, or your complaint fails to
      pass the review by the CIFTIS Digital Platform, you confirm that the
      CIFTIS Digital Platform has the right to freeze the funds for a long time,
      or return the relevant frozen funds to the source account (including but
      not limited to bank accounts, payment accounts, etc.).
      <br />
      5.4 Without prejudice to your use of the CIFTIS Digital Platform, the
      CIFTIS Digital Platform can transfer part or all of the contractual
      services to its affiliates or partners. To make this article take effect,
      both parties agree to sign all reasonable and necessary documents and take
      reasonable and necessary measures.
      <h3>6. Protection of privacy and other personal information</h3>
      Once you agree to this Terms of Service or use of this service, you agree
      the CIFTIS Digital Platform to use and disclose your personal information
      in accordance with the following terms.
      <br />
      6.1 Login username and password
      <br />
      When you register for an account, the CIFTIS Digital Platform will require
      you to set up a username and password for the CIFTIS Digital Platform
      account to identify you, and to set up a mobile phone or email as account
      associated information to confirm your identity when you lose the
      password. You can only use the account through the password you set. If
      you leak the password, you may lose your personal identification
      information which may cause legal consequences that are adverse to you. If
      the account and password are subject to potential or practical hazard for
      any reason, you should immediately contact the CIFTIS Digital Platform.
      The CIFTIS Digital Platform will not be responsible for such hazard before
      taking actions.
      <br />
      6.2 Bank account information
      <br />
      If the services provided by the CIFTIS Digital Platform require you to
      provide your bank account information, after you provide the corresponding
      information, the CIFTIS Digital Platform will strictly fulfill the
      relevant confidentiality agreement.
      <br />
      6.3 Login record
      <br />
      In order to ensure the security of your use of this service and to
      continuously improve the service quality, the CIFTIS Digital Platform will
      record and save the information about your login and use of this service,
      and promises not to provide such information to any third party (Except as
      otherwise agreed by both parties or otherwise stipulated by laws and
      regulations, or the affiliates of the CIFTIS Digital Platform).
      <br />
      6.4 Ads
      <br />
      The CIFTIS Digital Platform will make comprehensive statistics on the
      identity data of its users, and use or disclose it for sales and rewards.
      <br />
      6.5 External links
      <br />
      This website contains links to other websites, but the CIFTIS Digital
      Platform is not responsible for the privacy protection measures of other
      websites. The CIFTIS Digital Platform may add the websites of business
      partners or shared brands whenever it is needed.
      <br />
      6.6 Security
      <br />
      The CIFTIS Digital Platform only provides corresponding security measures
      according to the existing technology to prevent the information held by
      the CIFTIS Digital Platform from being lost, misused or altered. Such
      security measures include backing up data to other servers and encrypting
      user’s passwords. Despite such security measures, the CIFTIS Digital
      Platform does not guarantee the absolute security of such information.
      <br />
      6.7 User information
      <br />
      6.7.1. When you complete the account registration or account activation,
      you should provide your real name, address, nationality, phone number and
      email address to the CIFTIS Digital Platform. You can also choose to fill
      in relevant additional information (including but not limited to the
      province, city, time zone and postal code where your company is located in
      and your job title). You further understand and agree that when agreeing
      the Agreement or when you submit your personal information to the CIFTIS
      Digital Platform, you are about to transfer your data from your country to
      mainland China, and such transfer is the necessary step for performing the
      agreement between you and the CIFTIS Digital Platform and/or providing you
      with the services required by you.
      <br />
      6.7.2. In order to better provide services for you, the CIFTIS Digital
      Platform may automatically collect and save your software information,
      hardware information, the backup information which is automatically
      uploaded to cloud storage by default and the information actively uploaded
      by you to the server of the CIFTIS Digital Platform from your computer,
      mobile phone and other smart devices and browsers. The above information
      includes but is not limited to your CIFTIS Digital Platform account
      number, operating system information, IP address, cookie information, GPS
      information, the webpages you visited, and the contact persons, SMS,
      pictures and other information actively uploaded by you or automatically
      uploaded to cloud storage by default.
      <br />
      6.8 You further agree the CIFTIS Digital Platform to:
      <br />
      6.8.1. Send you customized information or new product/service information
      by email, telephone (including voice calls, faxes or information, if you
      indicate that we can contact you in this way);
      <br />
      6.8.2. Use your personal information for providing you with enhanced or
      analyzed statistical functions, or use or disclose your personal
      information for sales and rewards.
      <h3>7. System interruption or failure</h3>
      In case you cannot use various Internet services as the system fails to
      operate normally due to the following situations, the CIFTIS Digital
      Platform does not assume liability for damages. Such situations include
      but are not limited to:
      <br />
      7.1 The CIFTIS Digital Platform receives system maintenance after
      notifying the user in advance, including cutover, repair, upgrade, failure
      drill simulation, etc.
      <br />
      7.2 The telecommunication equipment fails and cannot transmit data.
      <br />
      7.3 Force majeure factors such as typhoons, earthquakes, tsunamis, floods,
      power outages, wars, terrorist attacks, etc. cause the CIFTIS Digital
      Platform system failing to do business.
      <br />
      7.4 Service interruptions or delays due to hacker attacks, technical
      adjustments or malfunctions in the telecommunications sector, website
      upgrades, bank problems, etc.
      <br />
      7.5 Caused by any network and equipment failure or configuration
      adjustments other than the equipment of the CIFTIS Digital Platform,
      including but not limited to various problems on the user side;
      <h3>8. Scope of liability and limitation of liability</h3>
      8.1 The CIFTIS Digital Platform is only responsible for the scope of
      liability listed in this Terms of Service.
      <br />
      <strong
        >8.2 The partners of this service should be responsible for the quality
        and content of the services provided by them.</strong
      >
      <br />
      <strong
        >8.3 You understand and agree that any third party claims arising from
        your use of this service, violation of this Terms of Service, or any
        action taken under your account should be borne solely by you. If the
        CIFTIS Digital Platform and its affiliates, employees, customers and
        partners are claimed by the third party, you should be responsible for
        handling it and take all the responsibilities caused thereby.</strong
      >
      <br />
      <strong
        >8.4 To the extent permitted by law, the CIFTIS Digital Platform is not
        responsible for any indirect, punitive, special, and derived losses
        (including business losses, loss in revenue, loss of profits, loss of
        use data, goodwill or other economic interests), no matter how it is
        generated, whether it is caused by a breach of this Terms of Service
        (including a breach of the guarantees) or by infringement, even if it
        has been informed in advance of the possibility of such losses. In
        addition, even if the exclusive remedies specified in this Terms of
        Service do not achieve their basic purpose, the liability of the CIFTIS
        Digital Platform for the aforementioned losses should be
        excluded.</strong
      >
      <br />
      <strong
        >8.5 Except as otherwise stipulated in this Terms of Service or
        otherwise agreed by the CIFTIS Digital Platform and you on a specific
        product and/or service, in any case, you agree that the total amount of
        liability of the CIFTIS Digital Platform for this Terms of Service does
        not exceed the total service fee charged to you.</strong
      >
      <h3>9. Entire agreement</h3>
      9.1 This Terms of Service is composed of this Terms of Service and the
      rules published on this website. Relevant terms are subject to
      cross-reference. If there is any conflict, this Terms of Service shall
      prevail.
      <br />
      9.2 The section titles of this Terms of Service are for convenience only,
      and should have no legal or contractual effect.
      <br />
      9.3 If you understand and agree this Terms of Service, you understand and
      agree the contents of all components of this Terms of Service. Once you
      use this service, you and the CIFTIS Digital Platform are bound by all the
      components of this Terms of Service.
      <br />
      9.4 In case part of the contents of this Terms of Service is determined as
      illegal by a court with jurisdiction, it does not affect the effectiveness
      of other contents.
      <h3>
        10. Protection of trademark right and intellectual property rights
      </h3>
      10.1 . The intellectual property rights (including but not limited to
      trademark right, patent right, copyright, trade secret, etc.) of all
      contents on this website (except third party products or services),
      including but not limited to works, pictures, files, information, data,
      architectures, and page design, are legally owned by the CIFTIS Digital
      Platform or its affiliates.
      <br />
      10.2. No one may use, modify, copy, publicly disseminate, change,
      distribute, issue or publicly publish the programs or contents on this
      website without the written consent of the CIFTIS Digital Platform or its
      affiliates.
      <br />
      10.3. You are obliged to respect the intellectual property rights and
      should assume liability for damages in case of violations.
      <br />
      10.4. As an exhibitor, I agree to abide by the Measures for the Protection
      of Intellectual Property Rights for Exhibitions and Measures for the
      Protection of Intellectual Property Rights for Exhibitions in Beijing, and
      accept the Procedures for the Handling Intellectual Property Complaints at
      Exhibitions formulated by the hosts and their complaint agencies in
      accordance with the above-mentioned measures. From now on to the end of
      this exhibition, the following commitments are made:
      <br />
      (a) Inspect the intellectual property rights involved in the exhibiting
      projects according to relevant regulations.
      <br />
      (b) Do not use exhibits, display boards, booths, promotional materials,
      etc. that infringe on the intellectual property rights of others in the
      exhibition hall.
      <br />
      (c) File complaints in accordance with the complaint procedures prescribed
      by the hosts or their complaint agencies, and will not affect the normal
      progress of the exhibition.
      <br />
      (d) Actively cooperate with the hosts or complaint agencies, relevant
      intellectual property administrative departments, and judicial organs in
      inquiries, inspections and evidence collection during the exhibition.
      <br />
      (e) Submit accurate, complete, true, legal and effective complaint
      materials.
      <br />
      (f) Do not make malicious complaints. If losses are caused to the hosts or
      the respondents due to malicious complaints, we are willing to bear
      corresponding legal liabilities.
      <br />
      (g) In violation of the above commitments, I am willing to accept the
      handling of the hosts or complaint agencies in accordance with the
      regulations of this exhibition.
      <br />
      <h3>11. Notice delivery</h3>
      11.1 . You understand and agree that the CIFTIS Digital Platform can
      notify you through web announcement, email, SMS or regular mail based on
      its own judgment, and can believe that the contact information provided by
      you is complete, accurate and currently valid. The above notice is deemed
      as having been delivered to the recipient on the date of sending.
      <br />
      11.2 . Unless otherwise stipulated in this Terms of Service or the
      agreement between you and the CIFTIS Digital Platform clearly stipulates
      the way of notification, the notice sent by you to the CIFTIS Digital
      Platform should be delivered through the mailing address, fax number,
      e-mail address and other contact information officially announced by the
      CIFTIS Digital Platform to the outside.
      <h3>12. Applicable laws and jurisdiction</h3>
      The validity, interpretation, modification, execution and dispute
      resolution of this Terms of Service should be governed by the laws of the
      People's Republic of China. Any disputes arising from this Terms of
      Service should be handled in accordance with the laws of the People's
      Republic of China.
    </section>
    <section v-else>
      <p>
        本协议是用户（“您”）与首都会展（集团）有限公司（以下简称为"服贸会数字平台"）之间就服贸会网站（www.ciftis.org，
        “本网站”）和服贸会移动APP（“本APP”）服务等相关事宜所订立的契约，请您仔细阅读本协议，您点击"同意"按钮后，本协议即构成对双方有约束力的法律文件。服贸会数字平台向用户提供本网站上所展示的产品与服务（下称“服贸会服务”、“本服务”），并将不断更新服务内容，最新的服贸会服务以本网站和本APP上的相关产品及服务介绍的页面展示以及向用户实际提供的为准。
      </p>
      <ol>
        <li>
          <h3>1、总则</h3>
          <ol>
            <li>
              1.1
              您确认：您在使用本服务之前，已经充分阅读、理解并接受本服务条款的全部内容（特别是以加粗及/或下划线标注的内容），一旦您选择“同意”并完成注册流程或使用本服务，即表示您同意遵循本服务条款之所有约定。
            </li>
            <li>
              <strong>
                1.2
                您同意：服贸会数字平台有权随时对本服务协议及相应的服务规则内容进行单方面的变更，并有权以消息推送、网页公告等方式予以公布，而无需另行单独通知您；若您在本服务条款内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的条款内容使用本服务；若您不同意修改后的服务条款，您应立即停止使用本服务。
              </strong>
            </li>
          </ol>
        </li>
        <li>
          <h3>2、账户</h3>
          <ol>
            <li>
              <h4>2.1 注册</h4>
              <ol>
                <li>
                  2.1.1 注册者资格
                  <ol>
                    <li>
                      （1）您确认：在您完成注册程序或以其他服贸会数字平台允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下统称为“法律主体”）。
                    </li>
                    <li>
                      <strong
                        >（2）若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果，且服贸会数字平台有权注销（永久冻结）您的账户，并向您及您的监护人索偿。</strong
                      >
                    </li>
                  </ol>
                </li>
                <li>
                  2.1.2 注册、账户和实名认证
                  <ol>
                    <li>
                      （1）在您按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，或您以其他服贸会数字平台允许的方式实际使用本网站和本APP服务时，您即受本服务条款约束。您可以使用您提供或确认的邮箱、手机号码或者服贸会数字平台允许的其它方式作为登录手段进入本网站。
                    </li>
                    <li>
                      （2）您了解并同意，您在本网站或本APP完成注册程序并注册成功后，您即已获得服贸会数字平台账户。
                    </li>
                    <li>
                      （3）目前服贸会数字平台仅允许一个服贸会数字平台账户对应唯一的法律主体。除非有法律规定或生效法律文书确定，或者符合服贸会数字平台公布的条件，否则您不得以任何方式转让、赠与或让他人继承您的服贸会数字平台账户。同时，在进行符合条件的服贸会数字平台转让、赠与或继承时，服贸会数字平台有权要求您、及/或受让受赠者、或您的继承人提供合格的文件材料并按照服贸会数字平台要求的操作流程办理。
                    </li>
                    <li>
                      （4）您了解并同意，为保证账户、交易和参展安全，服贸会数字平台有权随时要求您完成服贸会数字平台账户的实名认证；同时，服贸会数字平台可能会就某些产品或服务的开通，要求您提供更多的身份资料和信息，做进一步的身份认证或资格验证，您的账户只有在通过这些认证和验证之后，方可获得使用相关产品或服务的资格。
                    </li>
                    <li>
                      <div>
                        （5）通常情况下，您的服贸会数字平台账户是您在本网站或本APP进行一切活动的唯一身份识别依据，每一个服贸会数字平台账户都可以在本网站独立开展活动。但在下列情形下，服贸会数字平台有权根据自己的判断，对同一及/或关联法律主体拥有的多个服贸会数字平台账户进行统一处理，包括但不限于：
                      </div>
                      <ol>
                        <li>
                          a)
                          多个服贸会数字平台账户之间存在主账户与子账户、授权账户与被授权账户等关联关系，且根据法律法规、本服务条款或其他服贸会数字平台规则的规定，各账户之间互相承担连带责任的；
                        </li>
                        <li>
                          b)
                          多个服贸会数字平台账户使用同一实名认证，且其中两个或两个以上服贸会数字平台账户同时存在恶意违反法律法规、本服务条款或其他服贸会数字平台规则的行为的；
                        </li>
                        <li>
                          c）多个服贸会数字平台账户之间存在一项或多项注册信息相同或其他关联情形，并存在恶意违反法律法规、本服务条款、其他服贸会数字平台规则的行为，且服贸会数字平台通过结合其他相关证据足以判断上述服贸会数字平台账户实际属于同一法律主体或同一团体的；
                        </li>
                        <li>
                          d)
                          其他服贸会数字平台有充足理由需要对多个服贸会数字平台账户进行统一处理的情形。
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  2.1.3 信息
                  <ol>
                    <li>
                      （1）在完成注册流程时，您应当按照法律法规要求，按相应页面的提示准确提供并及时更新您的资料，以使之真实、及时，完整和准确。如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，服贸会数字平台有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部服务。
                      <strong
                        >服贸会数字平台对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。</strong
                      >
                    </li>
                    <li>
                      （2）您应当准确填写并及时更新您提供的电子邮件地址、联系电话（或手机号码）、联系地址、邮政编码等联系方式，以便服贸会数字平台或其他会员与您进行有效联系，
                      <strong
                        >因通过这些联系方式无法与您取得联系，导致您在使用服贸会数字平台服务过程中产生任何损失或增加费用的，应由您完全独自承担。</strong
                      >您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按服贸会数字平台的要求进行操作。
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <h4>2.2 账户安全</h4>
              <ol>
                <li>
                  2.2.1
                  您须自行负责对您的服贸会数字平台账户和密码保密，且须对您在该登录名和密码下发生的所有活动（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。您同意：(a)如发现任何人未经授权使用您的服贸会数字平台账户和密码，或发生违反保密规定的任何其他情况，您会立即通知服贸会数字平台，并授权服贸会数字平台将该信息同步给服贸会相关服务系统；及(b)确保您在每个上网时段结束时，以正确步骤离开网站。服贸会数字平台不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。您理解服贸会数字平台对您的请求采取行动需要合理时间，
                  <strong
                    >服贸会数字平台对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</strong
                  >
                </li>
                <li>
                  2.2.2
                  您理解并同意，服贸会数字平台有权了解您使用本网站产品及服务的真实背景及目的，有权要求您如实提供真实、全面、准确的信息；如果服贸会数字平台有合理理由怀疑您提供的信息不真实、您进行虚假交易，或您的行为违反服贸会数字平台规则的，服贸会数字平台有权暂时或永久限制您账户下所使用的所有产品及/或服务的部分或全部功能。
                </li>
                <li>
                  2.2.3您理解并同意，基于运行和交易安全的需要，服贸会数字平台有权暂时停止或者限制您账号下部分或全部功能。
                </li>
                <li>
                  2.2.4
                  您理解并同意，服贸会数字平台有权按照国家司法、行政、军事、安全等机关（包括但不限于公安机关、检察机关、法院、海关、税务机关、安全部门等）的要求对您的个人信息及在本网站及/或本APP的资金、交易及账户等进行查询、冻结或扣划。
                </li>
              </ol>
            </li>
            <li>
              <h4>2.3 账户注销</h4>
              <ol>
                <li>
                  2.3.1
                  服贸会数字平台保留在您违反国家、地方法律法规规定或违反本服务条款的情况下，中止或终止为您提供部分或全部服务、直至注销服贸会数字平台账户的权利。
                </li>
                <li>
                  2.3.2用户名的注销
                  <ol>
                    <li>
                      <strong
                        >（1）您理解并同意，如您连续12个月未使用您的用户名、邮箱、手机或本网站认可的其他方式和密码登录过本网站，服贸会数字平台有权注销您的用户名，您将不能再登录服贸会数字平台网站或APP。</strong
                      >
                    </li>
                    <li>
                      （2）您同意并授权服贸会数字平台，如您在服贸会数字平台或线下服贸会或其他北京市国际服务贸易事务中心举办的线下展会有欺诈、发布或销售伪劣商品、侵犯他人合法权益或其他严重违反任一服贸会数字平台规则的行为，服贸会数字平台及其相关的服务系统对此有权披露，您的服贸会数字平台用户名可能被注销，被注销后您不能再登录服贸会数字平台网站和APP，服贸会数字平台服务同时终止。
                    </li>
                  </ol>
                </li>
                <li>
                  2.3.3
                  您保证不会采取任何影响、损害或可能影响、损害服贸会数字平台及/或其关联公司、关联的线上及/或线下展会（包括但不限于：中国国际服务贸易交易会、中国北京国际文化创意产业博览会、北京国际金融博览会、北京国际旅游博览会、国际冬季运动（北京）博览会、北京国际机器人展览会等）及其主办单位、承办单位的合法权益，前述影响或损害服贸会数字平台合法权益的行为或方式包括但不限于：

                  <ol>
                    <li>
                      2.3.3.1
                      违反服贸会数字平台公布的任何服务协议/条款、管理规范、交易规则等规范内容；
                    </li>
                    <li>2.3.3.2 破坏或试图破坏服贸会数字平台正常运行秩序；</li>
                    <li>
                      2.3.3.3
                      任何使用含有服贸会名称、品牌且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与服贸会数字平台具有某种关系的；
                    </li>
                    <li>
                      2.3.3.4服贸会数字平台根据自行合理判断，认为可能是与如上行为性质相同或产生如上类似风险的其他情况。
                    </li>
                  </ol>
                  <p>
                    您认可服贸会数字平台有权在您违反上述约定时有权终止向您提供服务，即您将不能再登录服贸会数字平台网站和APP，所有服贸会数字平台的服务将同时终止。
                  </p>
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <h3>3、网站服务使用守则</h3>

          <p>为有效保障您使用本服务的合法权益，您理解并同意接受以下规则：</p>
          <ol>
            <li>
              <div>
                3.1
                您通过包括但不限于以下方式向服贸会数字平台发出的指令，均视为您本人的指令，不可撤回或撤销，您应自行对服贸会数字平台执行前述指令所产生的任何结果承担责任。
              </div>
              <ol>
                <li>3.1.1 通过您的服贸会数字平台账户和密码进行的所有操作；</li>
                <li>
                  3.1.2
                  通过与您的账号绑定的手机号码向服贸会数字平台发送的全部信息；
                </li>
                <li>
                  3.1.3
                  通过与您的账号绑定的其他硬件、终端、软件、代号、编码、代码、其他账户名等有形体或无形体向服贸会数字平台发送的信息；
                </li>
                <li>
                  3.1.4
                  其他服贸会数字平台与您约定或服贸会数字平台认可的其他方式。
                </li>
              </ol>
            </li>
            <li>
              3.2
              您在使用本服务过程中，本服务条款内容、页面上出现的关于交易操作的提示或服贸会数字平台发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，您使用本服务即表示您同意接受本服务的相关规则。您了解并同意服贸会数字平台有权单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示（或发送到该手机的短信或电话等）为准，您同意并遵照服务规则是您使用本服务的前提。
            </li>
            <li>
              3.3
              服贸会数字平台可能会以电子邮件（或发送到您手机的短信或电话等）方式通知您服务进展情况以及提示您进行下一步的操作，但服贸会数字平台不保证您能够收到或者及时收到该邮件（或发送到该手机的短信或电话等），且不对此承担任何后果。因此，在服务过程中您应当及时登录到本网站查看和进行交易操作。因您没有及时查看和对服务状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，服贸会数字平台不负任何责任。
            </li>
            <li>
              3.4
              您授权服贸会数字平台可以通过向第三方审核您的身份和资格，取得您使用本服务的相关资料。
            </li>
            <li>
              3.5
              在您开始使用服贸会数字平台的某一产品或服务前，可能需要和服贸会数字平台就这一产品或服务签订单独的服务协议。您只有在接受该服务协议的全部内容后方可使用该产品或服务；如您不同意该服务协议的部分或者全部的，请您不要进行后续操作。
            </li>
            <li>
              3.6您在使用服贸会数字平台相应产品和服务时，服贸会数字平台会与您签订具体的服务协议（包括但不限于各产品的服务条款及服务等级协议等），具体产品的服务协议与本协议有冲突的，以具体的服务协议为准，具体协议未做约定的，以本协议为准。
            </li>
            <li>
              <h4>3.7 申诉及处理</h4>
              <ol>
                <li>
                  3.7.1
                  在您使用服贸会数字平台服务的过程中，有可能因为存在本服务条款第5.3条所列情形之一，而被服贸会数字平台采取了包括但不限于停止全部或部分服务、限制服务的全部或部分功能、冻结全部或部分账户资金等措施，服贸会数字平台将通过邮件、站内信、短信或电话等方式通知您按照相应的程序进行申诉。
                </li>
                <li>
                  3.7.2
                  您通过申诉程序，向服贸会数字平台申请解除上述限制或冻结或恢复服务的，应按照服贸会数字平台的要求，如实提供身份证明及相关资料，以及服贸会数字平台要求的其他信息或文件，以便服贸会数字平台进行核实。您应充分理解您的申诉并不必然被允许，服贸会数字平台有权依照自行判断来决定是否同意您的申诉请求。
                </li>
                <li>
                  <strong>
                    3.7.3
                    您理解并同意，如果您拒绝如实提供身份证明及相关资料的，或未能通过服贸会数字平台审核的，服贸会数字平台有权长期冻结该等账户且长期限制该等产品或者服务的部分或全部功能。
                  </strong>
                </li>
              </ol>
            </li>
            <li>
              <h4>3.8关于第三方</h4>
              <ol>
                <li>
                  <strong>
                    3.8.1
                    如果您通过使用本服务，将获取使用来自第三方的任何产品或服务，您还可能受限于该等第三方的相关条款和条件，服贸会数字平台对此不予过问亦不承担任何责任，本服务条款不影响您与该第三方的法律关系。
                  </strong>
                </li>
                <li>
                  3.8.2
                  您确认并同意，服贸会数字平台的各关联公司均为本服务条款的第三方受益人，且服贸会数字平台关联公司有权直接强制执行并依赖本服务条款中授予其利益的任何规定。除此之外，任何第三方均不得作为本服务条款的第三方受益人。
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <h3>4、您的权利和义务</h3>
          <ol>
            <li>
              4.1
              您有权利享受服贸会数字平台提供的互联网技术和信息服务，并有权利在接受服贸会数字平台提供的服务时获得服贸会数字平台的技术支持、咨询等服务，服务内容详见本网站相关产品介绍。
            </li>
            <li>
              <div>
                4.2您保证不利用服贸会数字平台服务从事危害国家利益、集体利益和公民合法利益的活动，不得危害服贸会数字平台服务自身安全，或利用技术或其他手段破坏或扰乱服贸会数字平台其他客户的网站，不得制作、复制、发布含有下列内容的违法信息：
              </div>
              <ol>
                <li>(一)反对宪法所确定的基本原则的；</li>
                <li>
                  (二)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                </li>
                <li>(三)损害国家荣誉和利益的；</li>
                <li>
                  (四)歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
                </li>
                <li>
                  (五)宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
                </li>
                <li>(六)煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                <li>(七)破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                <li>(八)散布谣言，扰乱经济秩序和社会秩序的；</li>
                <li>
                  (九)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                </li>
                <li>
                  (十)侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
                </li>
                <li>(十一)法律、行政法规禁止的其他内容。</li>
              </ol>
            </li>
            <li>
              <div>
                4.3依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：
              </div>
              <ol>
                <li>
                  （1）从中国大陆向境外传输资料信息时必须符合中国有关法规；
                </li>
                <li>
                  （2）不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
                </li>
                <li>
                  （3）不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统
                </li>
                <li>
                  （4）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；
                </li>
                <li>
                  （5）不得教唆他人从事违法违规或本协议、平台规则所禁止的行为；
                </li>
                <li>（6）不得利用在本网站注册的账户进行牟利性经营活动；</li>
                <li>
                  （7）不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容；
                </li>
              </ol>
            </li>
            <li>
              4.4您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据。
            </li>
            <li>
              4.5您应尊重服贸会数字平台及其他第三方的知识产权和其他合法权利，并保证在发生侵犯上述权益的违法事件时尽力保护服贸会数字平台及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；服贸会数字平台保留您侵犯服贸会数字平台合法权益时终止向您提供服务并不退还任何款项的权利。
            </li>
            <li>
              4.6
              对由于您向服贸会数字平台提供的联络方式有误、手机号停止使用、以及您用于接受服贸会数字平台邮件的电子邮箱安全性、稳定性不佳而导致的一切后果，您应自行承担责任，包括但不限于因您未能及时收到服贸会数字平台的相关通知而导致的后果和损失。
            </li>
            <li>
              <h4>4.7您保证：</h4>
              <ol>
                <li>
                  4.7.1.您使用服贸会数字平台产品或服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，防范和抵制制作、复制、发布含有下列内容的不良信息：使用夸张标题，内容与标题严重不符的；炒作绯闻、丑闻、劣迹等的；不当评述自然灾害、重大事故等灾难的；带有性暗示、性挑逗等易使人产生性联想的；展现血腥、惊悚、残忍等致人身心不适的；煽动人群歧视、地域歧视等的；宣扬低俗、庸俗、媚俗内容的；可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；其他对网络生态造成不良影响的内容。
                </li>
                <li>
                  <div>
                    4.7.2.
                    使用服贸会数字平台产品或服务时，应遵守您与服贸会数字平台签订的服务条款、服贸会数字平台在www.ciftis.org相关页面上的管理规范、流程、服务说明、价格说明和您确认同意的订购页面的内容，包括但不限于：
                  </div>
                  <ol>
                    <li>（1）您不应出现任何破坏或试图破坏网络安全的行为等；</li>
                    <li>
                      （2）您不得通过使用服贸会数字平台的服务利用任何非经网络审查、备案或依靠技术手段进行跨境非法信息的传输。
                    </li>
                  </ol>
                </li>
                <li>
                  <div>
                    4.7.3.
                    您以及您的关联方不是任何国家，国际组织或者地域实施的服贸易限制，制裁或者其他法律限制的对象。
                  </div>
                  <p>
                    如您违反上述保证，服贸会数字平台有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权限制您账户如参会参展、商业推广等部分或全部功能，涉嫌违法行为的将向相关司法监管部门举报。如因您上述行为给服贸会数字平台造成损失的，您应予赔偿。
                  </p>
                </li>
              </ol>
            </li>
            <li>
              4.8
              若您使用的某项服务中包含可下载的服贸会数字平台软件，则服贸会数字平台仅授予您非独占性的、不可转让的、非商业运营目的的个人使用许可。除非服贸会数字平台另有明示或与您另有约定外，您不得复制、修改、发布、出售或出租服务或所含软件的任何部分，也不得进行反向工程或试图提取该软件的源代码。
            </li>
            <li>
              4.9如您部署在服贸会数字平台上的经营信息系统达到或必须符合国家等级保护定级或行业、主管部门指定要求的，您应依法满足相应级别安全要求，获得相应安全认证或认可，并自行承担和负责相关的部门的安全检查。
            </li>
          </ol>
        </li>
        <li>
          <h3>5、服贸会数字平台的权利和义务</h3>
          <ol>
            <li>
              5.1
              服贸会数字平台应根据您选择的服务以及交纳款项的情况向您提供合格的网络技术和信息服务。
            </li>
            <li>
              <div>
                5.2
                服贸会数字平台承诺对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：
              </div>
              <ol>
                <li>
                  5.2.1
                  依据本服务条款或者您与服贸会数字平台之间其他服务协议、合同、在线条款等规定可以提供；
                </li>
                <li>5.2.2 依据法律法规的规定应当提供；</li>
                <li>5.2.3 行政、司法等职权部门要求服贸会数字平台提供；</li>
                <li>5.2.4 您同意服贸会数字平台向第三方提供；</li>
                <li>5.2.5 服贸会数字平台解决举报事件、提起诉讼而提交的；</li>
                <li>
                  5.2.6
                  服贸会数字平台为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；
                </li>
                <li>
                  5.2.7
                  服贸会数字平台为向您提供产品、服务、信息而向第三方提供的，包括服贸会数字平台通过第三方的技术及服务向您提供产品、服务、信息的情况。
                </li>
              </ol>
            </li>
            <li>
              <div>
                5.3当存在如下情形之一时，服贸会数字平台有权对您名下账户功能及账户资金的部分或全部进行冻结：
              </div>
              <ol>
                <li>5.3.1 国家法律、法规、政策、法律文书的规定：</li>
                <li>5.3.2 国家有权机关要求进行冻结的：</li>
                <li>
                  5.3.3
                  您使用服贸会数字平台服务的行为涉嫌违反国家法律法规及行政规定的；
                </li>
                <li>
                  5.3.4
                  服贸会数字平台基于单方面合理判断，认为您的账户操作、资金进出等存在异常时；
                </li>
                <li>
                  5.3.5 他人向您账户错误汇入资金等导致您可能存在不当得利的：
                </li>
                <li>5.3.6 您遭到他人投诉，且对方已经提供了一定证据的：</li>
                <li>
                  5.3.7
                  服贸会数字平台根据自行合理判断，认为可能产生风险的其他情况。
                </li>
              </ol>
              <p>
                服贸会数字平台按照前述规定对您的账户资金进行冻结后，将通过邮件、站内信、短信或电话等方式通知您按照相应的程序进行申诉。如果您未在规定时间内进行申请，或您的申诉未能通过服贸会数字平台审核的，则您确认服贸会数字平台有权长期冻结该资金，或将相关冻结款项按原路退回该笔资金的充值来源账户（包括但不限于银行账户、支付账户等）。
              </p>
            </li>
            <li>
              5.4在不影响您使用服贸会数字平台的前提下，服贸会数字平台可将合约部分或全部服务转让予服贸会数字平台之关联企业或合作伙伴。为本款生效之需要，双方同意签订所有合理必要的文件及采取合理必要的措施。
            </li>
          </ol>
        </li>
        <li>
          <h3>6、隐私及其他个人信息的保护</h3>
          <p>
            一旦您同意本服务条款或使用本服务，您即同意服贸会数字平台按照以下条款来使用和披露您的个人信息。
          </p>
          <ol>
            <li>
              <div>6.1 登录用户名和密码</div>
              <p>
                在您注册帐户时，服贸会数字平台会要求您设置服贸会数字平台账户用户名和密码来识别您的身份，并设置手机或邮箱作为账户关联信息，以便在您丢失密码时用以确认您的身份。您仅可通过您设置的密码来使用该账户，如果您泄漏了密码，您可能会丢失您的个人识别信息，并可能导致对您不利的法律后果。该账户和密码因任何原因受到潜在或现实危险时，您应该立即和服贸会数字平台得联系，在服贸会数字平台采取行动前，服贸会数字平台对此不负任何责任。
              </p>
            </li>
            <li>
              <div>6.2 银行账户信息</div>
              <p>
                若服贸会数字平台所提供的服务需要您提供您的银行账户信息，在您提供相应信息后，服贸会数字平台将严格履行相关保密约定。
              </p>
            </li>
            <li>
              <div>6.3 登录记录</div>
              <p>
                为了保障您使用本服务的安全以及不断改进服务质量，服贸会数字平台将记录并保存您登录和使用本服务的相关信息，但服贸会数字平台承诺不将此类信息提供给任何第三方（除双方另有约定或法律法规另有规定及服贸会数字平台关联公司外）。
              </p>
            </li>
            <li>
              <div>6.4 广告</div>
              <p>
                服贸会数字平台会对服贸会数字平台用户的身份数据进行综合统计，并出于销售和奖励的需要使用或披露。
              </p>
            </li>
            <li>
              <div>6.5 外部链接</div>
              <p>
                本网站含有到其他网站的链接，但服贸会数字平台对其他网站的隐私保护措施不负任何责任。服贸会数字平台可能在任何需要的时候增加商业伙伴或共用品牌的网站。
              </p>
            </li>
            <li>
              <div>6.6 安全</div>
              <p>
                服贸会数字平台仅按现有技术提供相应的安全措施来使服贸会数字平台掌握的信息不丢失，不被滥用和变造。这些安全措施包括向其他服务器备份数据和对用户密码加密。尽管有这些安全措施，但服贸会数字平台不保证这些信息的绝对安全。
              </p>
            </li>
            <li>
              <div>6.7 用户信息</div>
              <ol>
                <li>
                  6.7.1.
                  您完成账户注册或账户激活时，应向服贸会数字平台提供您的真实姓名、地址、国籍、电话号码和电子邮件地址，您还可以选择来填写相关附加信息（包括但不限于您公司所在的省份和城市、时区和邮政编码和您的职务）。您进一步理解并同意，在同意本协议时或在您将您的个人信息提交至服贸会数字平台时，您即将您的数据自您的所在国家转移至中国大陆，而且该等转移是为履行您和服贸会数字平台所订立至协议和/或为您提供您所要求之服务的必要步骤。
                </li>
                <li>
                  6.7.2.
                  为了更好的为您提供服务，服贸会数字平台有可能自动从您的电脑、手机等智能设备和浏览器上收集和存储您的软件信息、硬件信息、默认状态自动上传云存储的备份信息、您主动上传至服贸会数字平台服务器的信息，上述信息包括但不限于您服贸会数字平台帐号，操作系统信息，您的IP地址，Cookie信息，GPS等位置服务使用情况，您所访问的页面，您主动上传或默认状态自动上传至云存储的联系人、短信、图片等信息。
                </li>
              </ol>
            </li>
            <li>
              <div>6.8 您进一步同意服贸会数字平台：</div>
              <ol>
                <li>
                  6.8.1.
                  向您发送定制化的信息或新产品/服务信息，通过电邮、电话（包括语音电话、传真或信息，如果您表明我们可以以此方式联系您）；
                </li>
                <li>
                  6.8.2.
                  出于为您提供增强或分析的统计功能使用您的个人信息，或者出于销售或鼓励的目的使用或披露个人信息。
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <h3>7、系统中断或故障</h3>
          <p>
            系统可能因下列状况无法正常运作，使您无法使用各项互联网服务时，服贸会数字平台不承担损害赔偿责任，该状况包括但不限于：
          </p>
          <ol>
            <li>
              7.1
              服贸会数字平台预先通知用户后进行系统维护所引起的，包括割接、维修、升级和模拟故障演练等。
            </li>
            <li>7.2 电信设备出现故障不能进行数据传输的。</li>
            <li>
              7.3
              因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成服贸会数字平台系统障碍不能执行业务的。
            </li>
            <li>
              7.4
              由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。
            </li>
            <li>
              7.5任何服贸会数字平台所属设备以外的网络、设备故障或配置调整引起的，包括但不限于用户端的各中问题等；
            </li>
          </ol>
        </li>
        <li>
          <h3>8、责任范围及责任限制</h3>
          <ol>
            <li>8.1 服贸会数字平台仅对本服务条款中列明的责任承担范围负责。</li>
            <li>
              <strong>
                8.2
                本服务之合作单位，所提供之服务品质及内容由该合作单位自行负责。
              </strong>
            </li>
            <li>
              <strong>
                8.3
                您了解并同意，因您使用本服务、违反本服务条款或在您的账户下采取的任何行动，而导致的任何第三方索赔，应且仅应由您本人承担。如果由此引起服贸会数字平台及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并承担由此造成的全部责任。
              </strong>
            </li>
            <li>
              <strong>
                8.4
                在法律允许的情况下，服贸会数字平台对于与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不论是如何产生的，也不论是由对本服务条款的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本服务条款规定的排他性救济没有达到其基本目的，也应排除服贸会数字平台对上述损失的责任。
              </strong>
            </li>
            <li>
              <strong>
                8.5
                除本服务条款另有规定或服贸会数字平台与您就某一具体产品及/或服务另有约定外，在任何情况下，您同意服贸会数字平台对本服务条款所承担的赔偿责任总额不超过向您收取的当次服务费用总额。
              </strong>
            </li>
          </ol>
        </li>
        <li>
          <h3>9、完整协议</h3>
          <ol>
            <li>
              9.1
              本服务条款由本服务条款与本网站公示的各项规则组成，相关名词可互相引用参照，如有不同理解，以本服务条款为准。
            </li>
            <li>
              9.2 本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。
            </li>
            <li>
              9.3
              您对本服务条款理解和认同，您即对本服务条款所有组成部分的内容理解并认同，一旦您使用本服务，您和服贸会数字平台即受本服务条款所有组成部分的约束。
            </li>
            <li>
              9.4
              本服务条款部分内容被有管辖权的法院认定为违法的，不因此影响其他内容的效力。
            </li>
          </ol>
        </li>
        <li>
          <h3>10、商标、知识产权的保护</h3>
          <ol>
            <li>
              10.1
              除第三方产品或服务外，本网站上所有内容，包括但不限于著作、图片、档案、资讯、资料、架构、页面设计，均由服贸会数字平台或服贸会数字平台关联企业依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
            </li>
            <li>
              10.2
              非经服贸会数字平台或服贸会数字平台关联企业书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站上程序或内容。
            </li>
            <li>
              10.3 尊重知识产权是您应尽的义务，如有违反，您应承担损害赔偿责任。
            </li>
            <li>
              <p>
                10.4
                作为参展商，我同意遵守《展会知识产权保护办法》和《北京市展会知识产权保护办法》的规定，并接受主办方及其投诉机构依上述办法制定的《展会知识产权投诉处理程序》。自即日起至本届展会结束期间做出如下承诺：
              </p>
              <p>（1）按照相关规定对参展项目涉及知识产权自行检查。</p>
              <p>
                （2）不在展馆内使用侵犯他人知识产权的展品、展板、展台、宣传资料等。
              </p>
              <p>
                （3）按照主办方或者其设立的投诉机构规定的投诉程序进行投诉，不影响展会的顺利进行。
              </p>
              <p>
                （4）积极配合主办方或者投诉机构以及相关知识产权行政管理部门、司法机关在展会期间进行的询问、勘验、取证等工作。
              </p>
              <p>（5）提交的投诉材料准确、完整、真实、合法、有效。</p>
              <p>
                （6）不进行恶意投诉。如因恶意投诉给主办方或者被投诉人造成损失的，愿承担相应法律责任。
              </p>
              <p>
                （7）违反本承诺，愿意按本展会的规定接受主办方或者投诉机构的处理。
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h3>11、通知送达</h3>
          <ol>
            <li>
              11.1
              您理解并同意，服贸会数字平台可依据自行判断，通过网页公告、电子邮件、手机短信或常规的信件传送等方式向您发出通知，且服贸会数字平台可以信赖您所提供的联系信息是完整、准确且当前有效的；上述通知于发送之日视为已送达收件人。
            </li>
            <li>
              11.2
              除非本服务条款另有约定或服贸会数字平台与您另行签订的协议明确规定了通知方式，您发送给服贸会数字平台的通知，应当通过服贸会数字平台对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。
            </li>
          </ol>
        </li>
        <li>
          <h3>12、法律适用与管辖</h3>
          <p>
            本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生之争议，均应依照中华人民共和国法律予以处理。
          </p>

          <!-- <p>
            注：需要特别说明的是，我们的产品承诺并确认上传至软件商店的应用软件（具体名称为【
            服贸会APP 】，(APPID: com.jdcloud.fumaohui
            ）已获得该软件著作权人【北京京东尚科信息技术有限公司】（注：北京京东叁佰陆拾度电子商务有限公司和北京京东尚科信息技术有限公司隶属于京东集团，是京东集团旗下关联公司。）合法授权，本公司有权将该软件上传至软件商店供用户下载。保证本应用软件所提供的内容（包括但不限于文字、图片、视频、音频等）均已获得合法授权，有权在本应用软件中传播使用，不存在任何侵犯第三方合法权益的情形（包括但不限于商标权，肖像权，版权等）。
          </p>

          <p>
            附件补充说明：<br />
            应用中集成第三方SDK说明：<br />
            阿里巴巴： fastjson 用于JSON解析； ARouter 用于路由跳转<br />
            腾讯：腾讯浏览器，微信分享，崩溃上报<br />
            华为：华为推送<br />
            科大讯飞：语言识别<br />
            imei: 用于数据上报，标识设备
          </p> -->
        </li>
      </ol>
    </section>
  </div>
</template>

<script>
import { getPolicyDetailById } from '@/api/newscenter-api'
import { getLang } from '@/utils'

export default {
  data() {
    return {
      lang: 'zh-CN',
      remoteContent: '',
      isLoading: true
    }
  },
  created() {
    const detectedLang = getLang()
    if (detectedLang) {
      this.lang = detectedLang
    }
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const {
        VUE_APP_REGISTRY_ID = '',
        VUE_APP_REGISTRY_EN_ID = ''
      } = process.env

      const targetId =
        this.lang === 'en-US'
          ? VUE_APP_REGISTRY_EN_ID || VUE_APP_REGISTRY_ID
          : VUE_APP_REGISTRY_ID

      if (!targetId) {
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        const response = await getPolicyDetailById(targetId, this.lang)
        const richText = this.extractRichText(response)
        if (richText && richText.trim().length > 0) {
          this.remoteContent = richText
        }
      } catch (error) {
        // Use bundled content as the fallback.
      } finally {
        this.isLoading = false
      }
    },
    extractRichText(response) {
      const result = response && response.result
      if (!result) {
        return ''
      }

      const container = result.content || result.data
      if (container && container.richText) {
        return container.richText.replace(
          /text-wrap-mode:\s*nowrap/g,
          'text-wrap-mode: wrap'
        )
      }

      return ''
    }
  }
}
</script>

<style scoped>
::v-deep table {
  border-collapse: collapse;
}
.agreement {
  padding: 20px;
  background: #fff;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  overflow-x: auto;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-overflow-scrolling: touch;
}
.agreement h3,
.agreement h4,
.agreement h5 {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
}
.agreement ol {
  margin: 0 0 12px;
}

.agreement p {
  margin: 0 0 12px;
  text-indent: 24px;
}
.agreement table {
  width: 100%;
  margin: 0 0 12px;
  border-collapse: collapse;
  display: block;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.agreement th,
.agreement td {
  padding: 6px 4px;
  border: 1px solid #ccc;
  white-space: normal;
  word-break: break-word;
}
.agreement th {
  background: #f0f0f0;
}
.agreement td {
  background: #fff;
}
.agreement > li h3,
.agreement > li h4,
.agreement > li h5 {
  margin: 0;
}
.agreement li div,
.agreement li p {
  margin: 0 0 12px;
  text-indent: 0;
}

@media screen and (min-width: 800px) {
  .agreement {
    max-width: 1200px;
    margin: 20px auto;
    font-size: 14px;
    line-height: 28px;
  }
}
.agreement img {
  max-width: 100%;
  height: auto;
}
</style>
